import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { AffiliationService } from '@services/affiliation.service';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { CommonService } from '@services/common.service';
import { BulkSearchService } from '@services/BulkSearchService';
import { Router } from '@angular/router';
import { LoaderComponent } from '@components/shared/loader/loader.component';
import { SearchProfileService } from '@services/search-profile.service';
@Component({
  selector: 'app-affiliation-view',
  standalone: true,
  imports: [CommonModule, MatPaginatorModule, LoaderComponent],
  templateUrl: './affiliation-view.component.html',
  styleUrls: ['./affiliation-view.component.scss'],
})
export class AffiliationViewComponent implements OnInit {
  commonService = inject(CommonService);
  viewMode: 'rollup' | 'rolldown' = 'rollup';

  rcmProfile: any[] = [];
  rcmId = '5001340192';
returnUrl: string = '';
  parentAffiliation: any[] = [];
  hcaChildAffiliation: any[] = [];
  hcpChildAffiliations: any[] = [];
  serchedAccountType: any;
  searchedAccountName: any;
  hcaHierarchyData: any;
  // ✅ HCA pagination
  paginatedHcaChildAffiliation: any[] = [];
  hcaPageSize = 5;
  hcaCurrentPage = 0;
  paginatedParentAffiliation: any[] = [];
parentPageSize = 5;
parentCurrentPage = 0;
  selectedParentGraphData: any = null;
  viewReady = false;
  searchState: any = null;
  // ✅ HCP pagination
  paginatedHcpChildAffiliation: any[] = [];
  hcpPageSize = 5;
  hcpCurrentPage = 0;
  isHcpType = false;
  isParentRowSelected = false;
  selectedParentRow: any = null;
  graphParentAffiliation: any[] = [];
  graphHcaChildAffiliation: any[] = [];
  graphHcpChildAffiliations: any[] = [];
  parentLevelSortDirection: 'asc' | 'desc' = 'asc';
  showLoader = this.commonService.showLoader;
  constructor(
    private affiliationService: AffiliationService,
    private cdr: ChangeDetectorRef,
    private bulkSearchService: BulkSearchService,
    private router: Router,
    private location: Location,
      private searchProfileService: SearchProfileService
  ) {}

  ngOnInit() {
    console.log('history.state', history.state);
console.log('selectedAffiliationProfile', this.commonService.selectedAffiliationProfile);
    this.commonService.setShowLoader(true);
    const data =
      this.commonService.selectedAffiliationProfile ||
      history.state?.selectedProfile;
      this.returnUrl = history.state?.returnUrl || '/main/crt/search';
      this.searchState = history.state;

    if (!data || !data.rcm_id) {
      this.router.navigate(['main', 'crt', 'search']);
      return;
    }

    this.rcmId = data.rcm_id;
    this.rcmProfile = [data];

    this.loadAffiliations(data.type, data.name);
  }

  setView(mode: 'rollup' | 'rolldown') {
    this.commonService.setShowLoader(true); // 👈 SHOW LOADER FIRST

    this.viewMode = mode;

    this.hcaCurrentPage = 0;
    this.hcpCurrentPage = 0;

    setTimeout(() => {
      if (this.hcaChildAffiliation?.length) {
        this.updateHcaPagination();
      }

      if (this.hcpChildAffiliations?.length) {
        this.updateHcpPagination();
      }

      this.commonService.setShowLoader(false); // 👈 hide after render
    }, 0);
  }

  // ======================
  // ✅ HCA PAGINATION
  // ======================
  onHcaPageChange(event: PageEvent) {
    this.hcaPageSize = event.pageSize;
    this.hcaCurrentPage = event.pageIndex;
    this.updateHcaPagination();
  }

  updateHcaPagination() {
    const start = this.hcaCurrentPage * this.hcaPageSize;
    const end = start + this.hcaPageSize;

    this.paginatedHcaChildAffiliation = this.hcaChildAffiliation.slice(
      start,
      end,
    );
  }

  // ======================
  // ✅ HCP PAGINATION
  // ======================
  onHcpPageChange(event: PageEvent) {
    this.hcpPageSize = event.pageSize;
    this.hcpCurrentPage = event.pageIndex;
    this.updateHcpPagination();
  }

  updateHcpPagination() {
    const start = this.hcpCurrentPage * this.hcpPageSize;
    const end = start + this.hcpPageSize;

    this.paginatedHcpChildAffiliation = this.hcpChildAffiliations.slice(
      start,
      end,
    );
  }
  onParentPageChange(event: PageEvent) {
  this.parentPageSize = event.pageSize;
  this.parentCurrentPage = event.pageIndex;

  this.updateParentPagination();
}

updateParentPagination() {
  const start = this.parentCurrentPage * this.parentPageSize;
  const end = start + this.parentPageSize;

  this.paginatedParentAffiliation = this.parentAffiliation.slice(
    start,
    end,
  );
}
sortParentAffiliationByLevel() {
  if (!this.isHcpType) {
    return;
  }

  this.parentLevelSortDirection =
    this.parentLevelSortDirection === 'asc' ? 'desc' : 'asc';

  this.parentAffiliation.sort((a, b) => {
    const levelA = Number(a.parent_level?.replace('L', '')) || 0;
    const levelB = Number(b.parent_level?.replace('L', '')) || 0;

    return this.parentLevelSortDirection === 'asc'
      ? levelA - levelB
      : levelB - levelA;
  });

  this.parentCurrentPage = 0;
  this.updateParentPagination();
}

  loadAffiliations(type: string, name: string) {
    if (!this.rcmId || !type) {
      this.commonService.setShowLoader(false);
      return;
    }
    this.isHcpType = type.toUpperCase() === 'HCP';
    if (type.toUpperCase() === 'HCA') {
      this.affiliationService
        .getHcaAffiliation(this.rcmId)
        .subscribe((res: any) => {
          this.parentAffiliation = res?.upward || [];
          this.parentCurrentPage = 0;
this.updateParentPagination();
          this.hcaChildAffiliation = res?.downward || [];
          this.hcpChildAffiliations = res?.hcp || [];
          // OPTIONAL: copy for graph
          this.graphParentAffiliation = [...this.parentAffiliation];
          this.graphHcaChildAffiliation = [...this.hcaChildAffiliation];
          this.graphHcpChildAffiliations = [...this.hcpChildAffiliations];
          this.serchedAccountType = res?.source_level;
          this.searchedAccountName = name;

          this.rcmProfile = res?.rcm_profile?.length
            ? res.rcm_profile
            : this.rcmProfile;

          this.hcaCurrentPage = 0;

          this.updateHcaPagination();
          this.commonService.setShowLoader(false);
        });
    } else if (type.toUpperCase() === 'HCP') {
      this.isHcpType = true;
      this.isParentRowSelected = false;
      this.affiliationService
        .getHcpAffiliation(this.rcmId)
        .subscribe((res: any) => {
          this.parentAffiliation = res?.parent_hierarchy || [];
          this.parentCurrentPage = 0;
this.updateParentPagination();
          // OPTIONAL graph copy
          this.graphParentAffiliation = [...this.parentAffiliation];
          this.serchedAccountType = 'L4';
          this.searchedAccountName = name;

          this.hcpCurrentPage = 0;

          this.updateHcpPagination();
          this.commonService.setShowLoader(false);
        });
    }
  }
  onParentRowClick(row: any) {

  if (!this.isHcpType) {
    return;
  }

  this.commonService.setShowLoader(true);

  this.selectedParentRow = row;
  this.isParentRowSelected = true;

  const parentRcmId = row.parent_hca_rcm_id;

  this.affiliationService
    .getHcaHierarchyChain(parentRcmId)
    .subscribe({
      next: (res: any) => {
        console.log('selected parent row data:', res);

        this.selectedParentGraphData = res;

        this.graphParentAffiliation = res?.hcp_parent_options || [];
        this.graphHcaChildAffiliation = res?.downward || [];
        this.graphHcpChildAffiliations = res?.hcp || [];

        this.commonService.setShowLoader(false);
      },
      error: () => {
        this.commonService.setShowLoader(false);
      }
    });
}
//  goBack() {
// this.location.back();
// }
goBack() {
  const rcmId = this.rcmProfile?.[0]?.rcm_id;

  if (!rcmId) {
    this.router.navigate(['/main/crt/search']);
    return;
  }

  this.openResultProfile(rcmId);
}
get showNoAffiliationMessage(): boolean {
  return (
    (!this.parentAffiliation || this.parentAffiliation.length === 0) &&
    (!this.hcaChildAffiliation || this.hcaChildAffiliation.length === 0) &&
    (!this.hcpChildAffiliations || this.hcpChildAffiliations.length === 0)
  );
}
  goToGraph() {
    this.router.navigate(['main', 'crt', 'affiliation-graph'], {
      state: {
        rcmId: this.rcmId,

        profile: this.rcmProfile,

        selectedParent: this.selectedParentGraphData,

        // 🚨 ALWAYS SEND GRAPH DATA ONLY
        parent: this.graphParentAffiliation,
        hca: this.graphHcaChildAffiliation,
        hcp: this.graphHcpChildAffiliations,

        type: this.serchedAccountType,
        name: this.searchedAccountName,
         returnUrl: this.returnUrl  
      },
    });
  }


openResultProfile(rcmId: string) {

  if (!rcmId) return;

  const params = {
    rcm_id: String(rcmId),
    name: '',
    address: '',
    dea: '',
    hin_no: '',
    id_340b: '',
    npi: '',
    sln: '',
    city: '',
    state: '',
    zip: '',
    type: 'Both',
    source: '',
    source_id: '',
    tddd: '',
    hcce: '',
    flag: true
  };

  // optional debug
  console.log('Sending params:', params);

  // 🔴 STEP 1: NAVIGATE FIRST
  this.router.navigate(['/main/crt/search'], {
  state: {
    searchPayload: params,
    openResult: true
  }
});

  // 🔴 STEP 2: SEND CLEAN STATE
  this.commonService.spSubject.next({ ...params });
}
}
